import { render, staticRenderFns } from "./empty-state.vue?vue&type=template&id=f7b0b856&scoped=true"
import script from "./empty-state.vue?vue&type=script&lang=js"
export * from "./empty-state.vue?vue&type=script&lang=js"
import style0 from "./empty-state.vue?vue&type=style&index=0&id=f7b0b856&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7b0b856",
  null
  
)

export default component.exports